function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m379.2 456c0 68.262-55.336 123.6-123.6 123.6-68.266 0-123.6-55.34-123.6-123.6s55.336-123.6 123.6-123.6c68.262 0 123.6 55.34 123.6 123.6z",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90 825.6h226.8c10.801-69.602 45.602-130.8 97.199-175.2-42-37.199-97.199-61.199-157.2-61.199-103.2 0-190.8 66-222 157.2-14.402 39.598 14.398 79.199 55.199 79.199z",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1068 456c0 68.262-55.336 123.6-123.6 123.6-68.262 0-123.6-55.34-123.6-123.6s55.336-123.6 123.6-123.6c68.266 0 123.6 55.34 123.6 123.6z",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1110 825.6h-226.8c-10.801-69.602-45.602-130.8-97.199-175.2 42-37.199 97.199-61.199 157.2-61.199 103.2 0 190.8 66 222 157.2 14.402 39.598-14.398 79.199-55.199 79.199z",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m723.6 498c0 68.262-55.34 123.6-123.6 123.6s-123.6-55.34-123.6-123.6 55.34-123.6 123.6-123.6 123.6 55.34 123.6 123.6z",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m765.6 867.6h-331.2c-40.801 0-69.602-39.602-56.398-78 32.398-91.199 120-157.2 222-157.2 103.2 0 190.8 66 222 157.2 14.398 38.398-15.602 78-56.398 78z",
    style: {
      fill: "#ffffff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupsIcon);
export default __webpack_public_path__ + "static/media/groups_icon.78fc48bfef1ad9f909bf5d7ecdf4d665.svg";
export { ForwardRef as ReactComponent };